import { Button, KdsText } from "@kazaar-platform/design-system";
import { RiArrowLeftLine } from "@remixicon/react";
import { T, useTranslate } from "@tolgee/react";
import { useSetAtom } from "jotai";
import { useAuth } from "@/hooks";
import { userAtom } from "@/store";
import { UserHasNoOrganisationPageWrapper } from "./UserHasNoOrganisationPageWrapper";

export const UserHasNoOrganisationPage = () => {
  const setUserAtom = useSetAtom(userAtom);

  const { t } = useTranslate();

  // Auth Hooks
  const { disconnect } = useAuth();

  const handleReturn = () => {
    disconnect();
    setUserAtom(undefined);
  };

  return (
    <UserHasNoOrganisationPageWrapper>
      <div className="flex flex-col">
        <div className="mb-6">
          <Button
            variant="secondary"
            size="s"
            icon={<RiArrowLeftLine strokeWidth={3} />}
            iconPosition="left"
            onPress={handleReturn}
          >
            {t("buttons.return")}
          </Button>
        </div>

        <div className="pb-2">
          <KdsText as="h2">{t("userHasNoOrganisation.title")}</KdsText>
        </div>

        <div className="pb-8 pt-2">
          <KdsText color="text-bodyvariant">
            <T
              keyName="userHasNoOrganisation.description"
              params={{ br: <br /> }}
            />
          </KdsText>
        </div>
      </div>
    </UserHasNoOrganisationPageWrapper>
  );
};
